// tracksApi.js — single helper for the /api/tracks endpoints.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

let _catalogue = null;

export async function fetchTrackCatalogue() {
  if (_catalogue) return _catalogue;
  const { data } = await axios.get(`${API}/tracks`);
  _catalogue = data;
  return data;
}

export async function fetchMyTrack() {
  const { data } = await axios.get(`${API}/tracks/me`);
  return data;
}

export async function selectTrack(trackId) {
  const { data } = await axios.post(`${API}/tracks/select`, { track_id: trackId });
  return data;
}

export async function markVideoWatched() {
  const { data } = await axios.post(`${API}/tracks/video-watched`);
  return data;
}

export async function submitInterest(answers) {
  const { data } = await axios.post(`${API}/tracks/interest`, { answers });
  return data;
}

export async function fetchRecommendations() {
  const { data } = await axios.get(`${API}/tracks/recommendations`);
  return data;
}
